module.exports = {
  API_URL: "https://d3d7cdbpcxi24d.cloudfront.net/api",
  PRODUCT_S3: "https://capno-product-image.s3.amazonaws.com",
  // API_URL : "http://localhost:5001/api",
};
